import { ContactInfo, TruckService } from '../types';

export const CONTACT_INFO: ContactInfo = {
  phone: '0543507981',
  email: 'mkashiff6@gmail.com',
  address: 'Al Quoz 4 Industrial Area, Dubai, UAE'
};

export const TRUCK_SERVICES: TruckService[] = [
  {
    id: '1-ton',
    title: '1 Ton Pickup Truck',
    capacity: '1 Ton',
    description: 'Perfect for small deliveries and light moving tasks',
    features: ['Tail Lift Available', 'Open & Box Options', '24/7 Service', 'Professional Driver'],
    image: '/1-ton-pickup-rental-truck-dubai.jpg'
  },
  {
    id: '3-ton',
    title: '3 Ton Pickup Truck',
    capacity: '3 Ton',
    description: 'Ideal for medium-sized moves and deliveries',
    features: ['Tail Lift Available', 'Open & Box Options', '24/7 Service', 'Professional Driver'],
    image: '/3-ton-pickup-rental-truck-dubai.jpg'
  },
  {
    id: '5-ton',
    title: '5 Ton Pickup Truck',
    capacity: '5 Ton',
    description: 'Great for larger moves and heavy deliveries',
    features: ['Tail Lift Available', 'Open & Box Options', '24/7 Service', 'Professional Driver'],
    image: '/5-ton-pickup-rental-truck-services.jpg'
  },
  {
    id: '7-ton',
    title: '7 Ton Pickup Truck',
    capacity: '7 Ton',
    description: 'Perfect for office moves and large deliveries',
    features: ['Tail Lift Available', 'Open & Box Options', '24/7 Service', 'Professional Driver'],
    image: '/7-ton-pickup-rental-truck-dubai.jpg'
  },
  {
    id: '10-ton',
    title: '10 Ton Pickup Truck',
    capacity: '10 Ton',
    description: 'Heavy-duty truck for commercial moves',
    features: ['Tail Lift Available', 'Open & Box Options', '24/7 Service', 'Professional Driver'],
    image: '/10-ton-pickup-rental-truck-dubai.jpg'
  }
];

/** Preferred domain for SEO – use this for canonicals, sitemap, and redirects (www vs non-www). */
export const CANONICAL_BASE_URL = 'https://www.pickuprentaltruckdubai.com';

export const COMPANY_INFO = {
  name: 'Pickup Rental Truck Dubai',
  tagline: 'Professional Pickup Truck Rental Services in Dubai',
  description: 'Pickup Rental Truck Dubai – leading pickup truck rental company offering 1-10 ton trucks with tail lift for home shifting, office moving and delivery in Dubai.',
  website: CANONICAL_BASE_URL
};
